import { get, writable } from 'svelte/store';
import { deepCompare, identity } from './util';
export class MessagesStore {
    constructor(messageRemoteRepository) {
        this.messageRemoteRepository = messageRemoteRepository;
        this.store = writable([]);
        this.subscribe = this.store.subscribe;
    }
    async addMessage(message) {
        this.store.update(messages => [...messages, message]);
        const serverMessage = await this.messageRemoteRepository.addMessage(message);
        Object.assign(message, serverMessage);
        this.store.update(identity);
    }
    update(messages) {
        const previous = get(this.store);
        if (!deepCompare(messages, previous)) {
            this.store.set(messages);
        }
    }
}
